import type { ContractEditorSeed } from "./contract-types";
export type Supplier = {
    id: string;
    name: string;
    status?: string;
};
export type SupplierDocument = {
    id: string;
    original_name?: string;
    originalName?: string;
    security_status?: string;
    securityStatus?: string;
    verification_status?: string;
    verificationStatus?: string;
    valid_until?: string | null;
    validUntil?: string | null;
};
const iso = (date: Date) => date.toISOString().slice(0, 10);
export function createContractEditorForm(seed: ContractEditorSeed | null | undefined, now: Date) {
    return {
        contractNo: seed?.contractNo ?? `SZL-${now.getFullYear()}-`,
        supplierId: seed?.supplierId ?? "",
        signedDocumentId: "",
        title: seed?.title ?? "",
        siteCode: seed?.siteCode ?? "ANL_MERKEZ",
        startDate: seed?.startDate ?? iso(now),
        endDate: seed?.endDate ?? iso(new Date(now.getTime() + 365 * 86400000)),
        currencyCode: seed?.currencyCode ?? "TRY",
        paymentTermDays: seed?.paymentTermDays ?? 45,
        deliveryTermDays: seed?.deliveryTermDays ?? 5,
        totalLimit: seed?.totalLimit ?? "",
        orderLimit: seed?.orderLimit ?? "",
        automaticOrderAuthorized: seed?.automaticOrderAuthorized ?? false,
        revisionReason: "",
        itemCode: seed?.items[0]?.itemCode ?? "",
        itemName: seed?.items[0]?.itemName ?? "",
        category: seed?.items[0]?.category ?? "Ambalaj",
        productGroupCode: seed?.items[0]?.productGroupCode ?? "GENEL-AMBALAJ",
        unitCode: seed?.items[0]?.unitCode ?? "KG",
        fixedUnitPrice: seed?.items[0]?.fixedUnitPrice ?? "",
        quantityLimit: seed?.items[0]?.quantityLimit ?? "",
        lineAmountLimit: seed?.items[0]?.lineAmountLimit ?? "",
    };
}
export type ContractEditorForm = ReturnType<typeof createContractEditorForm>;
export function isContractEditorFormValid(form: ContractEditorForm, revising: boolean) {
    return Boolean(form.contractNo.trim().length >= 3 && form.supplierId && form.signedDocumentId && form.title.trim().length >= 3 &&
        form.startDate && form.endDate >= form.startDate && Number(form.totalLimit) > 0 && Number(form.orderLimit) > 0 &&
        Number(form.orderLimit) <= Number(form.totalLimit) && form.itemCode.trim() && form.itemName.trim() &&
        Number(form.fixedUnitPrice) > 0 && (!revising || form.revisionReason.trim().length >= 10));
}
export function contractEditorPayload(form: ContractEditorForm, seed: ContractEditorSeed | null | undefined) {
    return {
        ...form,
        paymentTermDays: Number(form.paymentTermDays), deliveryTermDays: Number(form.deliveryTermDays),
        items: [{
                itemCode: form.itemCode.trim(), itemName: form.itemName.trim(), category: form.category,
                productGroupCode: form.productGroupCode.trim(), unitCode: form.unitCode.trim(), pricingType: "FIXED",
                fixedUnitPrice: String(form.fixedUnitPrice), pricePeriodStart: form.startDate, pricePeriodEnd: form.endDate,
                priceTolerancePercent: "0", quantityLimit: form.quantityLimit || null,
                lineAmountLimit: form.lineAmountLimit || null, additionalCostScope: [],
            }],
        ...(seed ? { expectedVersion: seed.currentVersion } : {}),
    };
}
export function eligibleContractDocuments(items: SupplierDocument[], now: Date) { return items.filter(item => { const validUntil = item.valid_until ?? item.validUntil; return (item.security_status ?? item.securityStatus) === "CLEAN" && (item.verification_status ?? item.verificationStatus) === "VERIFIED" && (!validUntil || new Date(validUntil) >= now); }); }
